import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import {
  onClickCancel,
  deleteSalesTypeRequest,
} from 'actions/businessLibrary/salesType';
import SettingField from 'components/Fields/ReduxForm/SettingField';

import styles from './SalesTypeDetail.css';

const validate = values => {
  const errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'This field is required';
  }
  if (values.name && values.name.length > 25) {
    errors.name = 'Sales Type Name should be less than 25 characters';
  }
  return errors;
};

class SalesTypeForm extends React.Component {
  render() {
    const {
      onClickCancel,
      handleSubmit,
      onSubmit,
      onClickDelete,
      isSubmittingForm,
      salesTypeDetail,
    } = this.props;

    return (
      <div className={`${styles.wrapper} sales-type-wrapper-form`}>
        <div
          ref={a => {
            this.scrollArea = a;
          }}
          className={`${styles['item-fieldset']} sales-type-item-fieldset`}
        >
          <div className={styles.title}>Sales Type Information</div>
          <div className="row">
            <div className="col-sm-12 mb-30px">
              <div className="col-sm-12 col-md-12 no-padding">
                <Field
                  component={SettingField}
                  name="name"
                  className="form-control"
                  placeholder="Sales Type Name (e.g. Dine In)"
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          {salesTypeDetail && salesTypeDetail.id && (
            <span className="pull-left btn-toolbar">
              <button
                className={'btn btn-danger'}
                onClick={() => onClickDelete(salesTypeDetail)}
                type="button"
                disabled={isSubmittingForm}
              >
                <i className="fa fa-trash" />
              </button>
            </span>
          )}
          <span className="pull-right">
            <button
              type="button"
              className={`btn btn-default ${styles['btn-cancel']}`}
              onClick={onClickCancel}
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              type="button"
              disabled={isSubmittingForm}
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </button>
          </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    isSubmittingForm,
    salesTypeDetail,
  } = state.businessLibrary.salesTypeHub;
  return {
    isSubmittingForm,
    salesTypeDetail,
  };
}

const mapDispatchToProps = {
  onClickCancel,
  onClickDelete: deleteSalesTypeRequest,
};

const mapForm = {
  form: 'salesTypeHub',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(SalesTypeForm));
